import { lazy } from "react";

export { CANDIDATES_LIST_PAGE } from "./candidates-list-path";
export const CandidatesListPage = lazy(() => import("./candidates-list"));
